export const Images = {
  logo: require('../assets/images/logo.webp'),
  groupname: require('../assets/images/group_name.webp'),
  excludedLogo: require('../assets/images/ExcludedLogo.webp'),
  ringOrange: require('../assets/images/ringOrange.webp'),
  ringGreen: require('../assets/images/ringGreen.webp'),
  ringBlue: require('../assets/images/ringBlue.webp'),
  diathriveDevice: require('../assets/images/white_device.webp'),
  diathriveDeviceInstruction: require('../assets/images/white_device_instruction.webp'),
  // ACON meter images
  aconDevice: require('../assets/images/diathrive-acon-transparent.webp'),
  aconDeviceInstruction: require('../assets/images/diathrive-acon-transparent.webp'),
  aconBtPairScreen: require('../assets/images/diathrive-acon-transparent.webp'), // TODO: Replace with actual page 16 user guide image
};
